import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['form', 'dropdown', 'datepicker'];

  async connect() {
    console.log('after-action controller connected');
    this.handleTrigger = this.onTrigger.bind(this);

    // If there are dropdowns, load jQuery and Select2 and add event listeners for them
    if (this._hasDropdowns()) {
      try {
        // Dynamically import jQuery and Select2
        const jQueryModule = await import('jquery');
        const $ = jQueryModule.default || jQueryModule;
        await import('select2');

        this.dropdownTargets.forEach((dropdown) => {
          $(dropdown).select2();
          $(dropdown).on('select2:select', (event) => this.onTrigger(event));
        });
      } catch (error) {
        console.error('Error loading jQuery or Select2:', error);
      }
    }
  }

  disconnect() {
    console.log('after-action controller disconnected');

    this.dropdownTargets.forEach((dropdown) => {
      $(dropdown).off('select2:select', (event) => this.onTrigger(event));
      $(dropdown).select2('destroy');
    });
    this.datepickerTargets.forEach((datepicker) => {
      datepicker.removeEventListener('change', (event) => this.onTrigger(event));
    });
  }

  onTrigger(event) {
    const { formAction, formMethod } = event.currentTarget.dataset;
    this.submitForm(formAction, formMethod);
  }

  submitForm(formAction, formMethod) {
    this._updateFormAttributes(formAction, formMethod);
    this.formTarget.requestSubmit();
    this._resetFormAttributes();
  }

  _updateFormAttributes(action, method) {
    this.oldAction = this.formTarget.action;
    this.oldMethod = this.formTarget.method;
    this.formTarget.action = action;
    this.formTarget.method = method;
  }

  _resetFormAttributes() {
    this.formTarget.action = this.oldAction;
    this.formTarget.method = this.oldMethod;
  }

  _hasDropdowns() {
    return this.dropdownTargets.length > 0;
  }
}
